import { Component,  ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import {  UntypedFormGroup,  } from '@angular/forms';
import { QuoteDataCaptureService, UtilService, SERVICE_END_POINT, AnalyticsService, CURRENT_ENVIROMENT,  } from 'src/app/shared';

import { Subscription, Observable } from 'rxjs';
import * as UserDataConfig from '../../config/user-data.config';
import { ClearToApply } from 'src/app/model/ngrx/clear-to-apply.model';

import { Location } from '@angular/common';
import * as BreadcrumbDataConfig from '../../../../common-components/config/user-data.config';


@Component({
  selector: 'app-user-login-required',
  templateUrl: './user-login-required.component.html',
  styleUrls: ['./user-login-required.component.scss']
})
export class  UserLoginRequiredComponent {
  userForm: UntypedFormGroup;
  userLoginRequiredForm: UntypedFormGroup;
  contentData;
  getQueryParameters;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public nextButtonDisabled: boolean;
  public noSelectedFlag: boolean;
  clearToApplyStore: Observable<ClearToApply[]>;
  clearToApply: ClearToApply;
  
  protected resposeJsonQuoteCaptureStore: {};
  protected resultQuote: {};
  protected CMSData;
  clearToApplyStoreSubscription: Subscription;
  isHOView = false;private subscripBeforeLogin: Subscription;
  public protectionTypeConfig = this.userInputDetail.protectionTypeConfig;
  displayLTAProtectionTypeWarningMsg: boolean = false;
  serverDetail: any;
  public displayAlert = false;
  private screenName;

  constructor(private activatedRoute: ActivatedRoute, 
              public el: ElementRef,
              private utilService: UtilService, 
              private location: Location,  
              private quoteDatacaptureService: QuoteDataCaptureService,
              public router: Router,
              private analyticsService: AnalyticsService
             ) {
              //console.log("Activated route content data :");
              //console.log(this.activatedRoute.snapshot.data.contentData);
    this.contentData = this.activatedRoute.snapshot.data.contentData.userLoginRequired;
    this.serverDetail = BreadcrumbDataConfig.BreadcrumbConfig.authServer;

  }

  ngOnInit() {
   this.GetCMSDataService();
  }
 
  GetCMSDataService() {
    const URL =  SERVICE_END_POINT.higherEnvironment.CMS_UserLoginRequired;
    this.utilService.getCMSData(URL)
    .subscribe(res => {
      ////console.log('2 GetCMSDataService => ', res);
      this.CMSData = res;
      if (this.CMSData) {
        //console.log('2 CMSData => ', this.CMSData);
      /** In the line below we are over-writing the contentData object values with CMSData object values */
        this.contentData.header = this.CMSData.commonBlock.String_Applying_Online;
        this.contentData.introduction = this.CMSData.commonBlock.String_Applying_Online_copy;
        this.contentData.subHeader = this.CMSData.commonBlock.String_To_start_your_application;
        this.contentData.loginRegistrationSteps = this.CMSData.commonBlock.String_To_start_your_application_copy;  
      }
    });
  }

  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

  backtoPrevious() {
    this.location.back();
   // this.router.navigate(['/home/get-your-online-quote']);
  }
  // gotoNext = () => {
  //   console.log("GO to Next");
  //   this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
  //     this.saveAfterLogin();
  //   });   
  // }
  afterSaveSuccessfully = () => {
    if (CURRENT_ENVIROMENT.environment !== 'localEnvironment') {
      // tslint:disable-next-line: max-line-length
      let serverName = '';
      if (document.location.href.toString().toUpperCase().includes('LOCALHOST')) {
        serverName = 'localhost';
      } else {
        if (document.location.href.indexOf('lgnet') > -1) {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('lgnet') - 1);
        } else {
          // tslint:disable-next-line: max-line-length
          serverName = document.location.href.substring(document.location.href.indexOf('//') + 2, document.location.href.indexOf('landg') - 1);
        }
      }
      const configServername = this.serverDetail.find(s => s.serverName === serverName);

      this.quoteDatacaptureService.loginRedirect(`${configServername.secAuthUrl}/SAuthGateWeb/login.html?domain=dcj&entryPoint=${configServername.entryPointUrl}%2Feap%2Frequest%2Fdcj%2FcustomerLogin`);
    } else {
      this.quoteDatacaptureService.postLoginCapture('', '', '').subscribe(res => {
        if (res.showWarning === 'Y') {
          this.displayAlert = true;
        } else {
          const redirectUrl = this.getScreenName(res.currentScreen);
          this.router.navigate([redirectUrl]);
          //this.router.navigate(['/home/guidance-and-advice']);
        }
      }, error => this.displayAlert = false);
    }
  }
  onLogin = () => {
    this.analyticsService.eventTrack({ type: 'ButtonClick', name: 'Login', pageID: this.getCurrentScreenURL() });
    this.afterSaveSuccessfully();
  }

  public getScreenName(currentscreen): string {
    const breadcrumbDetails = BreadcrumbDataConfig.BreadcrumbConfig.data.values;
    return breadcrumbDetails.find(br => br.screenName === currentscreen).path;
  }
  getCurrentScreenURL = () => {
    this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
    return this.screenName;
  }
  saveAfterLogin() {
    this.utilService.afterSaveSuccesfully()
  }

}